import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col xl:flex-row h-full xl:h-screen bg-secondary" }
const _hoisted_2 = {
  key: 0,
  class: "flex-1 grid min-h-0 grid-rows-[auto,1fr] bg-secondary"
}
const _hoisted_3 = { class: "flex gap-2 pl-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "xl:grid xl:grid-cols-[1fr,427px] min-h-0 bg-secondary pt-12 xl:pt-0" }
const _hoisted_6 = { class: "fixed bottom-0 left-0 w-full" }

import { onMounted, ref, watch } from "vue";
import SidebarMenu from "@/components/SidebarMenu.vue";
import TagSidebarItems from "@/components/sidebar/TagSidebarItems.vue";
import PageHeader from "@/components/headers/PageHeader.vue";
import { useBlogsStore } from "@/stores/blogsStore";
import BlogSidebar from "@/views/Blog/components/BlogSidebar.vue";
import BlogContent from "@/views/Blog/components/BlogContent.vue";
import BlogFooter from "@/views/Blog/components/BlogFooter.vue";
import PageFooter from "@/components/PageFooter.vue";
import { useLangStore } from "@/stores/langStore";
import { useSelectBlogTag } from "@/utils/useSelectBlogTag";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSafeBack } from "@/utils/useSafeBack";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const languageStore = useLangStore();
const blogStore = useBlogsStore();
const blogsCardsStore = useBlogsStore();
const { selectTag } = useSelectBlogTag();
const { safeBack } = useSafeBack();

const scrollContainer = ref<HTMLElement | null>(null);
const isMenuOpen = ref(false);

onMounted(() => {
  blogsCardsStore.loadBlogDetail(props.id);
});

watch(
  () => props.id,
  (newId) => {
    blogsCardsStore.loadBlogDetail(newId);
    if (scrollContainer.value) {
      scrollContainer.value.scrollTop = 0;
    }
  }
);

function closeBlog() {
  blogStore.currentBlogDetailId = null;
  safeBack(ROUTE_NAMES.BLOG_LIST);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarMenu, {
      "show-blog-btn": false,
      "is-menu-open": isMenuOpen.value,
      onToggleMenu: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value)),
      class: "sticky top-0"
    }, {
      default: _withCtx(() => [
        _createVNode(TagSidebarItems, {
          onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = false))
        })
      ]),
      _: 1
    }, 8, ["is-menu-open"]),
    (_unref(blogsCardsStore).blogDetail)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createVNode(PageHeader, { onClose: closeBlog }, {
            "header-content": _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogsCardsStore).blogDetail.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag,
                    class: "flex items-center h-[17px] md:h-[25px] xl:h-8 bg-ternary text-brown sf-pro font-semibold text-[11px] leading-100p md:text-sm md:leading-[21px] xl:text-base xl:leading-[24px] px-2 py-[2px] blu-[30px] rounded-lg tracking-normal cursor-pointer",
                    onClick: ($event: any) => (_unref(selectTag)(tag.id))
                  }, _toDisplayString(tag[_unref(languageStore).current] || tag[_unref(languageStore).fallbackLang]), 9, _hoisted_4))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "overflow-y-auto min-h-0 no-scrollbar",
              ref_key: "scrollContainer",
              ref: scrollContainer
            }, [
              _createVNode(BlogContent, {
                blog: _unref(blogsCardsStore).blogDetail
              }, null, 8, ["blog"]),
              _createVNode(BlogSidebar, {
                class: "xl:hidden",
                author: _unref(blogsCardsStore).blogDetail.author,
                "related-blogs": _unref(blogsCardsStore).blogDetail.related_blogs
              }, null, 8, ["author", "related-blogs"]),
              _createVNode(BlogFooter, {
                "related-blogs": _unref(blogsCardsStore).blogDetail.related_blogs
              }, null, 8, ["related-blogs"])
            ], 512),
            _createVNode(BlogSidebar, {
              class: "hidden xl:block",
              author: _unref(blogsCardsStore).blogDetail.author,
              "related-blogs": _unref(blogsCardsStore).blogDetail.related_blogs
            }, null, 8, ["author", "related-blogs"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(PageFooter)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})